import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { getCitiesByCountryWithinRegions, getCitiesLoading } from 'SRC/modules/geoObjects/cities/selectors'
import { fetchLocationsByCity } from 'SRC/modules/geoObjects/locations/actions'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

const City = ({
  regionsWithCitiesByCountry,
  citiesLoading,
  fetchLocationsByCity
}) => {
  const formik = useFormikContext()

  const selectedCity = formik.values.newUser ? formik.values.newUser.city : -1

  React.useEffect(() => {
    if (Number(selectedCity) !== -1) {
      fetchLocationsByCity(Number(selectedCity))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCity])

  const regions = formik.values.newUser ? regionsWithCitiesByCountry(formik.values.newUser.country) : []
  
  const cityOptions = Array.isArray(regions)
    ? regions.map(region => ({
        id: `${region.id}`,
        label: region.label,
        value: `${region.id}`,
        isGrouped: true,
        options: Array.isArray(region.cities)
          ? region.cities.map(city => ({
            id: `${city.id}`,
            label: city.label,
            value: `${city.id}`
          }))
          : []
    }))
    : []

  let cityError = ''

  if (formik.touched.newUser && formik.touched.newUser.city) {
    cityError = formik.errors.newUser && formik.errors.newUser.city
  }

  const isDisabled = citiesLoading || !formik.values.newUser.country ||
    Number(formik.values.newUser.country) === -1 || !Array.isArray(cityOptions) || !cityOptions.length

  return (
    <Wrapper isError={!!cityError}>
      <SelectDropdown
        id='newUser_city'
        title='Grad'
        isDisabled={isDisabled}
        isSearchable
        isRequired
        value={formik.values.newUser.city || -1}
        options={cityOptions}
        onChange={async city => {
          await formik.setFieldValue('newUser.city', city)

          if (!formik.touched.newUser || !formik.touched.newUser.city) {
            formik.setFieldTouched(`newUser.city`, true)
          }

          formik.setFieldValue('newUser.location', -1)
        }}
      />

      <ErrorMessage
        name='newUser.city'
        render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
      />
    </Wrapper>
  )
}

City.displayName = 'City'

const mapStateToProps = state => {
  const regionsWithCities = getCitiesByCountryWithinRegions(state)

  return {
    regionsWithCitiesByCountry: country => regionsWithCities[country],
		citiesLoading: getCitiesLoading(state)
  }
}

export default connect(mapStateToProps, { fetchLocationsByCity })(City)
